// Assessment page copy, word for word from the DIGU Site Reference artifact.
import { ROUTES } from './routes';

export const ASSESSMENT = {
  hero: {
    eyebrow: 'Assessment',
    title: 'Find out how safely your teams are already using Claude',
    lede: 'One week. We look at your real usage and configuration, score you against 32 controls, and give you a plan where every item has a price next to it.',
    actions: [
      { label: 'Book an assessment', to: ROUTES.contact },
      { label: 'Score yourself first', to: ROUTES.score, variant: 'ghost' },
    ],
  },

  whatYouGet: {
    eyebrow: 'What you get',
    title: 'Five artifacts, at the end of five days',
    items: [
      'A maturity profile across the five control domains, with your score today and the target we agree together',
      'A risk register, ranked, with the specific fix for each finding',
      'Your adoption baseline: seats bought against seats actually used, and what your teams are doing with them',
      'A ninety day plan, costed, where each line is either work you can do yourselves or an engagement we quote',
      'A thirty minute readout for your leadership, and a short deck you can forward',
    ],
  },

  theWeek: {
    eyebrow: 'The week',
    title: 'How it runs',
    days: [
      { k: 'Day 1', text: 'Agree scope, get read only access.' },
      { k: 'Days 2 to 3', text: 'Interviews, and a technical review of settings, workflows and cloud access.' },
      { k: 'Day 4', text: 'Analysis and scoring against the thirty two controls.' },
      { k: 'Day 5', text: 'The readout, with your leadership in the room.' },
    ],
    needs: {
      lead: 'What we need from you.',
      text: ' Read only access to your Claude administration, five interviews of forty five minutes, and access to a sample repository. No changes are made during the week.',
    },
    outOfScope: {
      lead: 'Out of scope.',
      text: ' We make no configuration changes during an assessment. Penetration testing and compliance certification are not included.',
    },
  },
};
